import React from "react";
import styled from "styled-components";

const DividerLine = () => {
  return <SectionTitle />;
};

export default DividerLine;

const SectionTitle = styled.div`
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  color: #1e293b;
  margin: 0;
  letter-spacing: -0.02em;
  position: relative;
  background: linear-gradient(135deg, #1e293b 0%, #10b981 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  &::after {
    content: "";
    position: absolute;
    top: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 120px;
    height: 4px;
    background: linear-gradient(90deg, #10b981, #eab308);
    border-radius: 2px;
  }
`;
